var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { mergeProps } from '@react-aria/utils';
import { useFocusRing } from '@react-aria/focus';
import { Text } from '../text';
import { useId } from '../hooks';
import { wrapperStyle, inputStyle, labelStyle } from './styles';
import Checkmark from './checkmark';
function CheckboxInternal(_a, ref) {
    var _b = _a.inverted, inverted = _b === void 0 ? false : _b, _c = _a.checked, checked = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.isIndeterminate, isIndeterminate = _e === void 0 ? false : _e, _f = _a.error, error = _f === void 0 ? false : _f, children = _a.children, ariaLabel = _a["aria-label"], restProps = __rest(_a, ["inverted", "checked", "disabled", "isIndeterminate", "error", "children", 'aria-label']);
    var _g = useFocusRing(), isFocusVisible = _g.isFocusVisible, focusProps = _g.focusProps;
    var checkboxId = "checkbox-".concat(useId());
    return (_jsxs("div", __assign({ css: wrapperStyle({ disabled: disabled }) }, { children: [_jsx("input", __assign({}, mergeProps(focusProps, restProps), { ref: ref }, (children && { id: checkboxId }), { type: "checkbox", disabled: disabled, checked: checked, "aria-checked": isIndeterminate ? 'mixed' : checked, "aria-invalid": error, "aria-label": ariaLabel, css: inputStyle({ disabled: disabled }) })), _jsx(Checkmark, __assign({}, { inverted: inverted, checked: checked, isIndeterminate: isIndeterminate, error: error, isFocusVisible: isFocusVisible })), children && (_jsx(Text, __assign({ as: "label", htmlFor: checkboxId, css: labelStyle({ disabled: disabled, inverted: inverted }) }, { children: children })))] })));
}
export default CheckboxInternal;
